// extracted by mini-css-extract-plugin
module.exports =  {"container":"_9cadcb71c3--container--Aej7u","icon":"_9cadcb71c3--icon--F7IUp"};